import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import dots from '../../../../Assets/Images/RedStation/Dots.png';
import bubbles from '../../../../Assets/Images/RedStation/Bubble.png';
import paths from '../../../../Assets/Images/RedStation/Paths.png';
import bigBubble from '../../../../Assets/Images/RedStation/BigBubble.png';
import device from '../../../../Assets/Responsive/breakpoints';

const Dots = styled.img.attrs({
  style: ({ scroll }) => ({
    transform: `translate(0px,-${scroll * 30}%)`
  })
})`
  transition: transform 0.2s ease-out;
  position: absolute;
  bottom: -170vh;
  left: 0vw;
  /* border: 1px dashed red; */
  height: 50vh;
  filter: blur(1.2px);
  @media ${device.mobileMaxWidth} {
    transform-origin: left center;
    bottom: -70vh;
    width: 80vw;
    height: 25vh;
  }
`;

const Bubbles = styled.img.attrs({
  style: ({ scroll }) => ({
    transform: `translate(0px,-${scroll * 23}%) scale(0.9)`
  })
})`
  position: absolute;
  bottom: -160vh;
  right: 1vw;
  transform-origin: right center;
  /* border: 1px dashed red; */
  height: 50vh;
  filter: blur(1.2px);
  @media ${device.mobileMaxWidth} {
    transform-origin: right center;
    bottom: -70vh;
    width: 80vw;
    height: 25vh;
  }
`;

const BigBubble = styled.img.attrs({
  style: ({ scroll }) => ({
    transform: `translate(0px,-${scroll * 10}%) scale(0.7)`
  })
})`
  bottom: -80vh;
  left: -4vw;
  position: absolute;
  /* border: 1px dashed red; */
  height: 50vh;
  filter: blur(1.2px);
  @media ${device.mobileMaxWidth} {
    transform-origin: left center;
    bottom: -40vh;
    left: 0vw;
    width: 100vw;
    height: 30vh;
  }
`;

const Paths = styled.img.attrs({
  style: ({ scroll }) => ({
    transform: `translate(0px,-${scroll * 3}%) scale(0.6)`
  })
})`
  bottom: -40vh;
  right: 1vw;
  transform-origin: right center;
  position: absolute;
  /* border: 1px dashed red; */
  height: 50vh;
  filter: blur(1.2px);
  @media ${device.mobileMaxWidth} {
    transform-origin: right center;
    bottom: -20vh;
    height: 30vh;
  }
`;

class RedStationImages extends Component {
  render() {
    let { scrollPercent } = this.props;
    const { boxHeight, index, scrollHeight, screenHeight } = this.props;
    const heighttoBeReducedinVH = boxHeight * index - 100;
    const scrollOffset = (screenHeight * heighttoBeReducedinVH) / 100;
    const scrollOffsetInPercent = (scrollOffset * 100) / scrollHeight;
    scrollPercent -= scrollOffsetInPercent;
    return (
      <React.Fragment>
        <Paths src={paths} scroll={scrollPercent} alt="paths" />
        <BigBubble src={bigBubble} scroll={scrollPercent} alt="bigBubble" />
        <Bubbles src={bubbles} scroll={scrollPercent} alt="bubbles" />
        <Dots src={dots} scroll={scrollPercent} alt="dots" />
      </React.Fragment>
    );
  }
}

RedStationImages.propTypes = {
  boxHeight: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  screenHeight: PropTypes.number.isRequired,
  scrollHeight: PropTypes.number.isRequired,
  scrollPercent: PropTypes.number.isRequired
};

export default RedStationImages;
